import { render, staticRenderFns } from "./CarDetails.vue?vue&type=template&id=23521fe6&scoped=true&"
import script from "./CarDetails.vue?vue&type=script&lang=js&"
export * from "./CarDetails.vue?vue&type=script&lang=js&"
import style0 from "./CarDetails.vue?vue&type=style&index=0&id=23521fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23521fe6",
  null
  
)

export default component.exports